import axios from 'axios'
import { apiObject } from './apiobject'

const newsBase = {
    uploadFile (articleId, fileObject) {
      return new Promise((resolve, reject) => {
        axios.post(`${this.url}${articleId}/uploadfile/`,
        fileObject,
          {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
          })
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    deleteFile (articleId, fileId) {
        return new Promise((resolve, reject) => {
          axios.delete(`${this.url}${articleId}/deletefile/${fileId}/`)
            .then(() => {
              resolve()
            }, error => {
              reject(error)
            })
          })
    },
    coverFile (articleId, fileId) {
        return new Promise((resolve, reject) => {
          axios.patch(`${this.url}${articleId}/coverfile/${fileId}/`, {
            id: fileId,
            cover_image: true
          })
            .then(() => {
              resolve()
            }, error => {
              reject(error)
            })
          })
    }
}

const news = {
  ...apiObject,
  url: '/notifications/news/',
  downloadFileUrl (articleId, fileId) {
    return axios.get(`${this.url}${articleId}/downloadfile/${fileId}/`, {
      responseType: 'arraybuffer'
    })
  },
  filePath(articleId, fileId) {
    return `${axios.defaults.baseURL}${this.url}${articleId}/downloadfile/${fileId}/`
  }
}

const cover_image = {
  url: '/notifications/cover/',
  filePath(fileId) {
    return `${axios.defaults.baseURL}${this.url}${fileId}/download/`
  }
}

const casenews = {
  url: '/notifications/casenews/',
  downloadFileUrl (caseType, articleId, fileId) {
    return axios.get(`${this.url}${caseType}/${articleId}/downloadfile/${fileId}/`, {
      responseType: 'arraybuffer'
    })
  },
  list ({ casetype, search, ordering, pageNum = 1, count = 10, filter = {}, searchField = 'Any' } = {}, ignoreErrorHandle = false) {
    var paramObject = Object.assign({}, { search, ordering, page: pageNum, count, search_field: searchField }, filter)
    return new Promise((resolve, reject) => {
      axios.get(`${this.url}${casetype}/`, {
        params: paramObject,
        ignoreErrorHandle: ignoreErrorHandle
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  get (casetype, id, ignoreErrorHandle = false) {
    return new Promise((resolve, reject) => {
      axios.get(`${this.url}${casetype}/${id}/`, {ignoreErrorHandle: ignoreErrorHandle})
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  filePath(casetype, articleId, fileId) {
    return `${axios.defaults.baseURL}${this.url}${casetype}/${articleId}/downloadfile/${fileId}/`
  }
}

const managecasenews = {
  ...casenews,
  url: '/notifications/managecasenews/',
  save (casetype, obj, ignoreErrorHandle = false) {
    return new Promise((resolve, reject) => {
      var id = null
      if (obj.id)
        id = obj.id
      if (obj instanceof FormData)
        id = obj.get('id')
      let request = (id)
          ? axios.patch(`${this.url}${casetype}/${id}/`, obj, {ignoreErrorHandle: ignoreErrorHandle})
          : axios.post(`${this.url}${casetype}/`, obj, {ignoreErrorHandle: ignoreErrorHandle})
      request.then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  uploadFile (casetype, articleId, fileObject) {
    return new Promise((resolve, reject) => {
      axios.post(`${this.url}${casetype}/${articleId}/uploadfile/`,
      fileObject,
        {
          headers: {
              'Content-Type': 'multipart/form-data'
          }
        })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  },
  deleteFile (casetype, articleId, fileId) {
      return new Promise((resolve, reject) => {
        axios.delete(`${this.url}${casetype}/${articleId}/deletefile/${fileId}/`)
          .then(() => {
            resolve()
          }, error => {
            reject(error)
          })
        })
  },
  coverFile (casetype, articleId, fileId) {
      return new Promise((resolve, reject) => {
        axios.patch(`${this.url}${casetype}/${articleId}/coverfile/${fileId}/`, {
          id: fileId,
          cover_image: true
        })
          .then(() => {
            resolve()
          }, error => {
            reject(error)
          })
        })
  }
}

const allnews = {
  ...apiObject,
  ...newsBase,
  url: '/notifications/allnews/'
}

export default {
    news,
    casenews,
    allnews,
    managecasenews,
    cover_image
}
